export function validatePassword(password, t) {
  if (!password || password.trim() === '') {
    return { valid: false, error: t('Bao.new_password_error') }
  }

  const passwordRegex = /^[a-zA-Z0-9]+$/

  if (/\s/.test(password) || !passwordRegex.test(password)) {
    return { valid: false, error: t('Bao.password_restrict_chars') }
  } else if (password.length < 6) {
    return { valid: false, error: t('Bao.password_restrict') }
  } else if (password.length > 20) {
    return { valid: false, error: t('Bao.password_restrict_20') }
  }

  return { valid: true, error: '' }
}
